/**
 * Drafts tab "Nothing to review yet" decision (pure, testable).
 *
 * The Drafts tab shows its empty state ONLY when there is genuinely nothing
 * to act on. Crucially it must NOT be empty when the user has CAPTURED
 * something this week but not drafted yet — otherwise the "Draft now" card
 * (the path from a capture, incl. a rest-day/weekend note, to a draft) is
 * hidden and the user is stuck.
 */
export type DraftsActivity = {
  hasWeekly: boolean;
  dailyReceiptCount: number;
  historyCount: number;
  /** Per-day captured-signal counts for the viewed week. */
  daySignalCounts: number[];
};

export function draftsIsEmpty(a: DraftsActivity): boolean {
  return (
    !a.hasWeekly &&
    a.dailyReceiptCount === 0 &&
    a.historyCount === 0 &&
    !a.daySignalCounts.some(n => n > 0)
  );
}
